import { render, staticRenderFns } from "./TodaysWorld.vue?vue&type=template&id=d118af14"
import script from "./TodaysWorld.vue?vue&type=script&lang=js"
export * from "./TodaysWorld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports